var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          ref: "formItem",
          style: _vm.$attrs["style"],
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            prop: _vm.$attrs["prop"],
            label: _vm.$attrs["label"],
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "el-col",
                { staticClass: "col_positon" },
                [
                  _c("el-input", {
                    staticClass: "left_input",
                    model: {
                      value: _vm.id,
                      callback: function ($$v) {
                        _vm.id = $$v
                      },
                      expression: "id",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "more_box flex_center flex_center_align" },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("@/assets/images/input_edit.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }